import styled from "styled-components"
import { Text } from "./"

export default styled(Text.withComponent("a")).attrs(
  ({ color, isCurrent }) => ({
    color: isCurrent ? "black" : color || "link"
  })
)`
  color: black;
  text-decoration: none;
  transition: color 180ms ease;
  &:hover {
    color: #666;
    text-decoration: none;
  }
`
